// 代理等级配置常量
export const AGENT_LEVEL_CONFIG = {
  1: {
    gradient:
      'linear-gradient(180deg, #9B713D 0%, rgba(161, 130, 69, 0.00) 100%)',
    badgeImage: require('@/pages/agent/assets/lv1.webp'),
    textMedium: '#7f5111',
    textDark: '#5e3b0a',
  },
  2: {
    gradient:
      'linear-gradient(180deg, #B05B35 0%, rgba(176, 91, 53, 0.00) 100%)',
    badgeImage: require('@/pages/agent/assets/lv2.webp'),
    textMedium: '#62280E',
    textDark: '#561E06',
  },
  3: {
    gradient:
      'linear-gradient(180deg, #601A97 0%, rgba(151, 41, 203, 0.00) 100%)',
    badgeImage: require('@/pages/agent/assets/lv3.webp'),
    textMedium: '#4B1270',
    textDark: '#420E64',
  },
  4: {
    gradient:
      'linear-gradient(180deg, #B1374A 0%, rgba(246, 112, 133, 0.00) 100%)',
    badgeImage: require('@/pages/agent/assets/lv4.webp'),
    textMedium: '#A40A23',
    textDark: '#6D0A1A',
  },
} as const;

export type AgentLevel = keyof typeof AGENT_LEVEL_CONFIG;

// Mock 数据配置
export const MOCK_TEAM_DATA = {
  1: {
    teamSize: {current: 10, target: 100}, // Team Size 显示纯数字
    teamRecharge: {current: 10340, target: 20000000}, // Team Recharge 使用 toPriceStr 格式化
    betRebate: '0.878%',
    rechargeRebate: '5%',
  },
  2: {
    teamSize: {current: 25, target: 200},
    teamRecharge: {current: 50000, target: 50000000},
    betRebate: '1.2%',
    rechargeRebate: '6%',
  },
  3: {
    teamSize: {current: 50, target: 500},
    teamRecharge: {current: 100000, target: 100000000},
    betRebate: '1.5%',
    rechargeRebate: '7%',
  },
  4: {
    teamSize: {current: 100, target: '∞'},
    teamRecharge: {current: 200000, target: '∞'},
    betRebate: '2%',
    rechargeRebate: '8%',
  },
} as const;
